import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Hero from "../components/Home/Hero";
import HomeProjectsSlider from "../components/Home/HomeProjectsSlider";
import Client from "../components/Home/OurClients";
import BusinessInfo from "../components/Home/BusinessInfo";
import Services from "../components/Home/Services";
import GiftingProducts from "../components/Home/GiftingProducts";
import HomeSkeleton from "../components/Home/HomeSkeleton";

const MIN_SKELETON_MS = 520;

function Home() {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      setShowContent(true);
      return undefined;
    }

    const t = window.setTimeout(() => setShowContent(true), MIN_SKELETON_MS);
    return () => window.clearTimeout(t);
  }, []);

  if (!showContent) {
    return <HomeSkeleton />;
  }

  return (
    <div className="home-content-reveal bg-surface">
      <Hero />
      <HomeProjectsSlider />
      <Client />
      <BusinessInfo />

      <section
        className="relative py-12 md:py-14 overflow-hidden"
        aria-labelledby="callback-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-brand-orange via-brand-amber to-brand-yellow opacity-[0.92]"
          aria-hidden
        />
        <div
          className="absolute inset-0 bg-[linear-gradient(180deg,transparent_0%,rgba(0,0,0,0.08)_100%)]"
          aria-hidden
        />
        <div className="container relative z-10 mx-auto px-4 text-center">
          <p className="text-black/75 font-bold text-xs uppercase tracking-[0.2em] mb-2">
            Expert free consultation
          </p>
          <h2
            id="callback-heading"
            className="text-2xl md:text-3xl font-bold text-black mb-5"
          >
            Get a callback
          </h2>
          <p className="text-black/80 text-sm max-w-lg mx-auto mb-6">
            Tell us about your storefront, office, or event—we&apos;ll call
            back with options and a ballpark that matches your brief.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center rounded-full bg-black px-8 py-3.5 text-sm font-bold text-white hover:bg-gray-900 transition-colors shadow-lg"
          >
            Ask for callback
          </Link>
        </div>
      </section>

      <Services />
      <GiftingProducts />
    </div>
  );
}

export default Home;
